import Palette from '@/styles/Themes/Palette';
import { cssVars } from '@/styles/Themes/cssVars';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 7px;

    @media (min-width: 1024px) {
        gap: 11px;
    }
`;

export const Label = styled.label<{ $required: boolean }>`
    font-weight: 600;
    font-size: 14px;
    max-width: max-content;
    color: ${cssVars.fg_grayDarker_white};

    ${({ $required }) =>
        $required &&
        css`
            &::after {
                content: '*';
                margin-left: 4px;
                color: ${Palette.state.error};
            }
        `}
`;

export const StyledInput = styled.input<{ $disabled: boolean }>`
    font-weight: 500;
    font-size: 16px;
    height: 40px;
    width: 100%;
    border-radius: 50px;
    border: 1px solid ${cssVars.border_gray3_dark1};
    padding: 0 25px 0 30px;
    color: ${cssVars.fg_gray1_gray3};
    background-color: ${cssVars.bg_white_dark3_input};
    outline: none;

    @media (min-width: 1024px) {
        height: 50px;
    }

    ${({ $disabled }) =>
        $disabled &&
        css`
            cursor: not-allowed;
            background-color: ${cssVars.bg_gray4_dark1};
            color: ${Palette.gray.gray2};
        `}
`;

export const ErrorBubble = styled.div`
    position: absolute;
    left: 0;
    top: 72px;
    z-index: 10;
    display: flex;
    min-height: 33px;
    width: 100%;
    align-items: center;
    border-radius: 15px;
    border: 1px solid ${cssVars.border_gray4_blue};
    background-color: ${cssVars.bg_errLight_errDark};
    padding: 9px 15px 6px;
    font-weight: 600;
    font-size: 14px;
    color: ${Palette.state.error};
    box-shadow: ${cssVars.shadow_card_default};

    &::before {
        content: '';
        position: absolute;
        top: -5px;
        left: 30px;
        height: 8px;
        width: 8px;
        transform: rotate(-45deg);
        border-right: 1px solid ${cssVars.border_gray4_blue};
        border-top: 1px solid ${cssVars.border_gray4_blue};
        background-color: ${cssVars.bg_errLight_errDark};
    }

    @media (min-width: 768px) {
        top: 76px;
    }

    @media (min-width: 1024px) {
        top: 89px;
    }
`;

export const ErrorContent = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 6px;

    @media (min-width: 768px) {
        gap: 7px;
    }
`;

export const ErrorIconWrapper = styled.div`
    flex-shrink: 0;
`;
